import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { howItWorksSteps } from '../../utils/howItWorksData';

/**
 * Reusable "How It Works" content component
 * Can be used inline (like in Login page) or in modals
 */
export const HowItWorksContent = ({ className = '' }) => {
  const [isSpanish] = useLanguage();

  return (
    <div className={className}>
      <div className="space-y-6">
        {howItWorksSteps.map((step) => (
          <div key={step.number} className="flex items-start gap-3">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#121212] text-white flex items-center justify-center font-semibold text-sm">
              {step.number}
            </div>
            <div>
              <h3 className="font-semibold mb-1 text-sm">
                {isSpanish ? step.title.esp : step.title.eng}
                {step.isOptional && (
                  <span className="text-xs text-gray-500 ml-1">
                    {isSpanish ? '(Opcional)' : '(Optional)'}
                  </span>
                )}
              </h3>
              <p className="text-xs text-gray-600">
                {isSpanish ? step.description.esp : step.description.eng}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorksContent;

